import { TrackerTeamLoading } from '@/views/tracker/team/tracker-team.loading';

export default TrackerTeamLoading;
